var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarModeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#4B33A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 11.6111C26.4444 10.9444 25.7778 10.5 25.1111 10.5H12.8889C12.1111 10.5 11.5556 10.9444 11.3333 11.6111L9 18.2778V27.1667C9 27.7222 9.55556 28.2778 10.1111 28.2778H11.2222C11.8889 28.2778 12.3333 27.7222 12.3333 27.1667V26.0556H25.6667V27.1667C25.6667 27.7222 26.2222 28.2778 26.7778 28.2778H27.8889C28.4444 28.2778 29 27.7222 29 27.1667V18.2778L26.6667 11.6111ZM13.2222 12.7222H24.6667L25.8889 16.0556H12.1111L13.2222 12.7222ZM26.7778 23.8333H11.2222V18.2778H26.7778V23.8333ZM14 19.3889C14.8889 19.3889 15.6667 20.1667 15.6667 21.0556C15.6667 21.9444 14.8889 22.7222 14 22.7222C13.1111 22.7222 12.3333 21.9444 12.3333 21.0556C12.3333 20.1667 13.1111 19.3889 14 19.3889ZM24 19.3889C24.8889 19.3889 25.6667 20.1667 25.6667 21.0556C25.6667 21.9444 24.8889 22.7222 24 22.7222C23.1111 22.7222 22.3333 21.9444 22.3333 21.0556C22.3333 20.1667 23.1111 19.3889 24 19.3889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarModeSelected);
export default __webpack_public_path__ + "static/media/carModeSelected.d75c7584775389ebdf1ab5e8117ac458.svg";
export { ForwardRef as ReactComponent };